export function Leaf({ className = "", size = "1em" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="leaf-grad" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#6D3DF5" />
          <stop offset="1" stopColor="#B15CFF" />
        </linearGradient>
      </defs>
      <path
        d="M41 5C27 6 12 14 9 33c-.3 2 .5 3.4 2.5 3C31 32.5 41 19 41 5Z"
        fill="url(#leaf-grad)"
      />
      <path d="M12.5 34.5C20 27 30 17 39.5 7.5" stroke="#F7F5FB" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function LeafTile({ size = 34, className = "" }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
      <defs>
        <linearGradient id="tile-leaf" x1="0" y1="1" x2="1" y2="0">
          <stop offset="0" stopColor="#6D3DF5" />
          <stop offset="1" stopColor="#B15CFF" />
        </linearGradient>
      </defs>
      <rect width="48" height="48" rx="12" fill="#262040" />
      <path d="M38 9C25 10 11 18 8.5 36c-.3 2 .6 3.3 2.6 2.9C29.5 35.5 38 23 38 9Z" fill="url(#tile-leaf)" />
      <path d="M11.5 37C19 29.5 28.5 19.5 36.5 11" stroke="#F7F5FB" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export default function Logo({ size = 30, showTagline = false, dark = false, className = "" }) {
  return (
    <span className={`inline-flex flex-col ${className}`} data-testid="nav-brand-logo">
      <span className="relative inline-flex items-end leading-none">
        <span
          className={`font-display text-[1.5em] font-extrabold lowercase tracking-[-0.02em] ${dark ? "text-nighttext" : "text-paper"}`}
          style={{ fontSize: size * 0.62 }}
        >
          carza
        </span>
        <Leaf className="absolute -top-[0.28em] -right-[0.5em] drop-shadow-[0_2px_6px_rgba(124,77,255,0.45)]" size={size * 0.56} />
      </span>
      {showTagline && (
        <span className="mt-1.5 whitespace-nowrap font-display text-[8px] font-semibold uppercase tracking-[0.34em] text-nighttext/80">
          Drive Cleaner. <span className="text-carza">Live Better.</span>
        </span>
      )}
    </span>
  );
}
